var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-2 md:mb-0" },
    [
      _c(
        "div",
        {
          staticClass:
            "features__wrapper w-full md:px-gap2 lg:container mt-0 md:mt-1",
        },
        [
          _c("div", { staticClass: "flex flex-wrap" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-12/12 text-center px-1 md:px-0 pt-2 md:py-2 md:py-4",
              },
              [_c("h2", [_vm._v(_vm._s(_vm.title))])]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "overflow-x-scroll w-full md:overflow-x-auto features__container mb-3",
        },
        [
          _c(
            "div",
            {
              staticClass: "features__table-wrapper md:w-auto mb-2 md:mb-0",
              class: `w-[${60 + 40 * _vm.length}vw]`,
            },
            [
              _c("ProductFeaturesHeader", {
                attrs: {
                  product: _vm.group,
                  globals: _vm.globals,
                  length: _vm.length,
                  specs: _vm.specs,
                  activeProduct: _vm.activeProduct,
                },
              }),
              _vm._v(" "),
              _c("ProductFeatureTable", {
                attrs: {
                  group: _vm.group,
                  product: _vm.product,
                  length: _vm.length,
                  globals: _vm.globals,
                  specs: _vm.specs,
                  activeProduct: _vm.activeProduct,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }